module.exports = __webpack_public_path__ + "static/img/institution03.dcd3bc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/institution03.png
// module id = f+rR
// module chunks = 1